'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _desc, _value, _class2, _descriptor;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _ProgressSpinner = require('../ProgressSpinner');

var _ProgressSpinner2 = _interopRequireDefault(_ProgressSpinner);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var TOP_THRESH = 800;
var BOTTOM_THRESH = 50;

var MessageScrollView = (0, _mobxReact.observer)(_class = (_class2 = function (_Component) {
  (0, _inherits3.default)(MessageScrollView, _Component);

  function MessageScrollView() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MessageScrollView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MessageScrollView.__proto__ || (0, _getPrototypeOf2.default)(MessageScrollView)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'shouldScrollBottom', _descriptor, _this), _this.scroll = function () {
      _this.checkScroll();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MessageScrollView, [{
    key: 'scrollToBottom',
    value: function scrollToBottom() {
      this.root.scrollTop = this.root.scrollHeight;
    }
  }, {
    key: 'checkScroll',
    value: function checkScroll() {
      var _this2 = this;

      var node = this.root;
      var scrollTop = node.scrollTop,
          offsetHeight = node.offsetHeight,
          scrollHeight = node.scrollHeight;

      var shouldScrollBottom = offsetHeight === scrollHeight || scrollTop + offsetHeight > scrollHeight - BOTTOM_THRESH;
      if (this.props.onLoadMore) {
        if (scrollTop < TOP_THRESH) {
          if (this._shouldNotifyLoadMore) {
            this._shouldNotifyLoadMore = false;
            this.props.onLoadMore();
          }
        } else {
          this._shouldNotifyLoadMore = true;
        }
      }
      (0, _mobx.runInAction)(function () {
        _this2.shouldScrollBottom = shouldScrollBottom;
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scrollToBottom();
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      // Record scroll position and children count.
      this._scrollPos = this.root.scrollTop;
      this._scrollHeight = this.root.scrollHeight;
      // if the next props says we have more messages,
      // we need to save the scroll position so we can
      // restore it after adding more messages.
      this._shouldSetScroll = this.props.messageCount < nextProps.messageCount;
      this.checkScroll();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var node = this.root;
      if (this.shouldScrollBottom) {
        this.scrollToBottom();
      } else if (this._shouldSetScroll) {
        var heightDiff = node.scrollHeight - this._scrollHeight;
        node.scrollTop = heightDiff + this._scrollPos;
        this._shouldSetScroll = false;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          children = _props.children,
          isLoadingMore = _props.isLoadingMore,
          scrollToBottom = _props.scrollToBottom;

      return _react2.default.createElement(
        'div',
        { className: 'message-scroll-view' },
        isLoadingMore && _react2.default.createElement(
          'div',
          { className: 'loading-more animated fadeIn is-faster' },
          _react2.default.createElement(
            'div',
            { className: 'spinner-block' },
            _react2.default.createElement(_ProgressSpinner2.default, { color: '#fff' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'text-block' },
            'Loading older messages...'
          )
        ),
        _react2.default.createElement(
          'div',
          { ref: function ref(x) {
              _this3.root = x;
            }, className: 'inner', onScroll: this.scroll },
          children
        ),
        !this.shouldScrollBottom && _react2.default.createElement(
          'div',
          { className: 'floating-actions animated fadeIn is-faster' },
          _react2.default.createElement(
            'button',
            { className: 'scroll-to-bottom', onClick: function onClick() {
                return _this3.scrollToBottom();
              } },
            scrollToBottom || 'Scroll to bottom'
          )
        )
      );
    }
  }]);
  return MessageScrollView;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'shouldScrollBottom', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
})), _class2)) || _class;

exports.default = MessageScrollView;


MessageScrollView.propTypes = {
  children: _propTypes2.default.node,
  isLoadingMore: _propTypes2.default.bool,
  scrollToBottom: _propTypes2.default.any,
  messageCount: _propTypes2.default.number.isRequired,
  onLoadMore: _propTypes2.default.func
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/MessageScrollView/index.js
// module id = 620
// module chunks = 0